import React, { FunctionComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { AppState } from '../../types/redux';
import { GenericButton } from '../GenericButton/GenericButton';

interface Props extends StateProps, DispatchProps {
	id?: string;
	className?: string;
	message?: string;
	disabled?: boolean;
	children?: ReactNode;
	onClick(): void;
	style?: React.CSSProperties;
}

let lastClickTimeStamp = 0;

const onClickAndRegisterTimestamp = (onClick: () => void) => {
	const thisClickTimeStamp = new Date().valueOf();

	if (thisClickTimeStamp - lastClickTimeStamp > 400) {
		lastClickTimeStamp = thisClickTimeStamp;
		onClick();
	}
};

const InternalContinueButton: FunctionComponent<Props> = (props) => (
	<GenericButton
		data-cy={props['data-cy']}
		style={{ whiteSpace: 'nowrap', ...props.style }}
		disabled={props.disabled || props.isLoading}
		id={props.id}
		className={`continue_button ${props.className}`}
		onClick={() => onClickAndRegisterTimestamp(props.onClick)}
		fullWidth={true}
	>
		{props.children}
	</GenericButton>
);

interface StateProps {
	isLoading: boolean;
}

interface DispatchProps {}

const mapStateToProps = (state: AppState) => ({
	isLoading: state.contractWizard.isLoading,
});

/* istanbul ignore next */
const mapDispatchToProps = (
	dispatch: ThunkDispatch<Promise<{}>, void, Action>
) => ({});

export const ContinueButton = connect(
	mapStateToProps,
	mapDispatchToProps
)(InternalContinueButton);
